import { render, staticRenderFns } from "./ShopView02.vue?vue&type=template&id=c6939c8a&scoped=true&"
import script from "./ShopView02.vue?vue&type=script&lang=js&"
export * from "./ShopView02.vue?vue&type=script&lang=js&"
import style0 from "./ShopView02.vue?vue&type=style&index=0&id=c6939c8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6939c8a",
  null
  
)

export default component.exports